import React , { useEffect, useState } from 'react';
import BackCard from '../Assets/backCard';
import InputLinks from '../Assets/linksData';
import { _ } from "gridjs-react";
import { Button, Dropdown, Icon, Input, Loader } from 'semantic-ui-react';
import TableGrid from '../../../Dashboard/Assets/tableGrid';
import axios from 'axios';
import GConf from '../../../AssetsM/generalConf';
import { toast } from 'react-toastify';
import SKLT from '../../../AssetsM/usedSlk';
import { useNavigate} from 'react-router-dom';

function InfoGenerale() {
    /*#########################[Const]##################################*/
    const navigate = useNavigate();
    let Offline = JSON.parse(localStorage.getItem(`Admin_Dir_Offline`));
    let [toShowFixList, setToShowFixedList] = useState([]);   
    let [selectedTable, setSetectedTable] = useState();  
    const options = [
        { key: 1, text: 'docteur', value: 'docteur'},
        { key: 2, text: 'pharmacie', value: 'pharmacie'},
        { key: 3, text: 'clinique', value: 'clinique'},
        { key: 4, text: 'laboratoire', value: 'labo'},
        { key: 5, text: 'centre medicale', value: 'centreMD'},
        { key: 6, text: 'Hopitale', value: 'admin_s_hospital'},
        { key: 7, text: 'centre de soins de base', value: 'admin_s_csb'},
        
        { key: 8, text: 'garderie', value: 'garderie' },
        { key: 9, text: 'ecole Priveé', value: 'ecole' },
        { key: 10, text: 'Lycee Priveé', value: 'lycee' },
        { key: 11, text: 'Universite Priveé', value: 'universite' },
        { key: 12, text: 'Formation', value : 'formation' },
        { key: 13, text: 'Librairie',value : 'librairie' },
        { key: 14, text: 'centre de formation', value: 'admin_e_centre' },
        { key: 15, text: 'bibliothéque ', value: 'admin_e_biblio' },
        { key: 151, text: 'Ecole Publique  ', value: 'admin_e_ecole' },
        { key: 152, text: 'Lycee Publique  ', value: 'admin_e_lycee' },
        { key: 153, text: 'Universite Piblique  ', value: 'admin_e_universite' },
        { key: 154, text: 'Rectorat ', value: 'admin_e_ss' },
        
        { key: 16, text: 'Transporteur',  value: 'transporteur' },
        { key: 17, text: 'Autoecole', value: 'autoecole' },
        
        { key: 18, text: 'Cafe', value: 'cafe' },
        { key: 19, text: 'Restaurant', value: 'restaurant' },
        { key: 59, text: 'Hotels',  value: 'hotels' },
        { key: 60, text: 'travel agency ', value: 'vg_agence' },

        { key: 20, text: 'Magazin', value: 'magazin' },
        { key: 21, text: 'Boulengerie', value: 'boulengerie' },
        { key: 22, text: 'Boucherie', value: 'boucherie' },
        { key: 23, text: 'Fruiterie', value: 'fruiterie' },
        { key: 24, text: 'Patesserie', value: 'patesserie' },
        { key: 25, text: 'Epecerie', value: 'epicerie' },
        { key: 26, text: 'Electromenager', value: 'electromenager' },
        { key: 27, text: 'Meuble', value: 'meublerie' },
        { key: 33, text: 'Quicaillerie', value: 'quincaillerie' },
        { key: 39, text: 'boutique', value: 'boutique' },
        { key: 55, text: 'Vente en gros', value: 'depot' },

        { key: 28, text: 'Location voiture', value: 'location' },
        { key: 29, text: 'Parking', value: 'parking' },
        
        { key: 30, text: 'Samsar ', value: 'courtier' },
        { key: 31, text: 'Contracteur', value: 'contracteur' },
        { key: 32, text: 'Architequte', value: 'architecture' },
        
        
        { key: 34, text: 'Forgeron', value: 'forgeron' },
        { key: 35, text: 'menuisier', value: 'menuisier' },
        { key: 36, text: 'peinture', value: 'peinture' },
        { key: 37, text: 'electricien', value: 'electricien' },
        { key: 371, text: 'Plombier', value: 'plombier' },
        { key: 372, text: 'cristalerie', value: 'cristalerie' },
        { key: 373, text: 'marbrerie', value: 'marbrerie' },
        
        { key: 38, text: 'coiffure', value: 'coiffure' },
        { key: 40, text: 'Salon marriage', value: 'salle_marriage' },
        { key: 41, text: 'Orchestre', value: 'orchestre' },
        { key: 42, text: 'Chef Cuisine', value: 'chef' },
        { key: 43, text: 'Photographe', value: 'photographe' },
        { key: 44, text: 'Vente fourniture marriage', value: 'fourniture_marriage' },
        { key: 45, text: 'Bijouterie', value: 'bijouterie' },
        
        { key: 46, text: 'Salle de sport',  value: 'gym' },
        { key: 47, text: 'Piscine',  value: 'pyscine' },
        { key: 48, text: 'Stade',  value: 'stade' },
        { key: 49, text: 'Cinema',  value: 'cinema' },
        { key: 50, text: 'Theatre', value: 'theatre' },
        { key: 51, text: 'Musee',  value: 'musee' },
        { key: 52, text: 'maison des jeunes ',  value: 'admin_c_mj' },
        { key: 53, text: 'maison de culture ', value: 'admin_c_mc' },
       
        { key: 54, text: 'Avocat',  value: 'avocat' },
        
        { key: 56, text: 'Comptable',  value: 'comptable' },
        { key: 58, text: 'Buerux de Poste ', value: 'admin_f_poste' },
        
        { key: 61, text: 'Municipaliteé',  value: 'admin_a_mu' },
        { key: 62, text: 'Agence de Police', value: 'admin_a_police' },
        { key: 63, text: 'Admin Regionale ',  value: 'admin_a_ar' },
        { key: 64, text: 'Court ',  value: 'admin_a_court' },


    ]
    /*#########################[Function]##################################*/
    const SearchInDirectory = () =>{
       if (!selectedTable) {toast.error("Selectionne un tableaux !", GConf.TostErrorGonf)}
       else {
        axios.post(`https://api.abyedh.com/api/application/Search/search/for-input`, {
          tag: selectedTable ,
          genre:'genre',
          gouv: Offline.localData[0].gouv,
          deleg : Offline.localData[0].deleg
        }).then(function (response) {
          let testTable = []
            response.data.map( (getData) => testTable.push([          
            getData.PID,
            getData.Name,
            getData.Deleg,
            getData.Adress,
            _(<Button className='rounded-pill bg-system-btn' size='mini' onClick={ (e) => NavigateFunction(`/Dir/L/if/edit/${selectedTable}/${getData.PID}`)}><span className='d-none d-lg-inline'> Info </span><Icon  name='angle right' /></Button>)
            ],))
            setToShowFixedList(testTable)
        }).catch((error) => {
          if(error.request) {
            toast.error(<><div><h5>مشل في الإتصال </h5> </div></>, GConf.TostInternetGonf) 
            setToShowFixedList([])
            }
        });
      }
    }

    const NavigateFunction = (link) => {  navigate(link) }

    /*#########################[Card]##################################*/
    return ( <>
        <BackCard data={InputLinks.backCard.edit}/>
        <br />
        
        <div className='container-fluid'>
          <div className='card card-body shadow-sm mb-3'>
                  <div className='mb-2 text-secondary'>Gouv :  {Offline.localData[0]  ? Offline.localData[0].gouv : ''}</div>
                  <div className='mb-2 text-secondary'>Deleg :  {Offline.localData[0]  ? Offline.localData[0].deleg : ''}</div>
                  <Dropdown
                    search
                    fluid
                    selection
                    wrapSelection={false}
                    options={options}
                    placeholder='Selectionez UN Tableaux'
                    onChange={(e, { value }) => setSetectedTable(value)}
                  />
                  <br />
                 <Button size='small'  fluid className=' rounded-pill bg-system-btn' icon onClick={(e) => SearchInDirectory()}>  <Icon name='search' /> Recherche </Button> 
          </div>
     
           <TableGrid tableData={toShowFixList} columns={['PID','Nom','Deleg','Adresse','Voir']} />
        </div>
        </> );
}


export default InfoGenerale;